(function () {
  const ADDED_CLASS = 'is-added';
  const ADDED_MS = 2500;

  function markAdded(button) {
    if (!button) return;
    button.classList.add(ADDED_CLASS);
    window.clearTimeout(button._circleAtcAddedTimer);
    button._circleAtcAddedTimer = window.setTimeout(() => {
      button.classList.remove(ADDED_CLASS);
    }, ADDED_MS);
  }

  function initCircleAtcButtons() {
    document.querySelectorAll('.card-circle-atc__btn:not([data-circle-atc-init])').forEach((button) => {
      button.dataset.circleAtcInit = 'true';
      button.addEventListener('click', () => {
        button.dataset.circleAtcPending = 'true';
      });
    });
  }

  function handleCartUpdate(event) {
    const pendingButtons = document.querySelectorAll('.card-circle-atc__btn[data-circle-atc-pending="true"]');
    if (pendingButtons.length) {
      pendingButtons.forEach((button) => {
        markAdded(button);
        delete button.dataset.circleAtcPending;
      });
      return;
    }

    if (!event?.productVariantId) return;

    document
      .querySelectorAll(`.card-circle-atc__btn[data-variant-id="${event.productVariantId}"]`)
      .forEach((button) => markAdded(button));
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCircleAtcButtons);
  } else {
    initCircleAtcButtons();
  }

  document.addEventListener('shopify:section:load', initCircleAtcButtons);
})();
